import VersumHealthConfig from './VersumHealth';
import BCPTNConfig from './BCPTN';
import CignaConfig from './Cigna';
import ProvidenceConfig from './Providence';
import BCBSKSConfig from './BCBSKS';
import CloverConfig from './Clover';
import HCSCConfig from './HCSC';


const clientConfigs = {
    VERSUM_HEALTH: VersumHealthConfig,
    BCPTN: BCPTNConfig,
    CIGNA: CignaConfig,
    PROVIDENCE: ProvidenceConfig,
    BCBSKS: BCBSKSConfig,
    CLOVER: CloverConfig,
    HCSC: HCSCConfig,
}

export default clientConfigs;
